import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import T from 'i18n-react';
// import fetch from 'cross-fetch';
import { formatBytes } from 'util/icwUtility';
import { getShareFiles, getBulkDownloadFiles } from 'actions/fileAction';

import {
  Container,
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
} from '@material-ui/core';
import icwLogo from 'assets/img/icw-logo.png';
import moment from 'moment';
import _ from 'lodash';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: '16px',
  },
  table: {
    boxShadow: '0.5px 1px 1px 1px #c7c7c7',
    borderTop: '3px solid #2154A2',
  },
  tableHead: {
    fontSize: '12px',
    fontWeight: 'bold',
    color: '#979797',
  },
}));

const SharePage = () => {
  const classes = useStyles();
  const [files, setFiles] = React.useState([{}]);
  const { pathname } = window.location;
  const token = pathname.substring(pathname.indexOf('/') + 12, pathname.length);

  useEffect(() => {
    getShareFiles(token).then((result) => {
      setFiles(result);
    });
  }, [token]);

  const handleDownloadAll = () => {
    const ids = _.flattenDeep(
      Object.keys(files.files).map((key) => files.files[key].fileArr.filter((file) => file.id))
    );

    getBulkDownloadFiles(ids).then((content) => {
      const buffer = new Uint8Array([...content.content.data]).buffer;
      const blob = new Blob([buffer], { type: 'application/zip' });
      const url = URL.createObjectURL(blob);
      window.open(url);
    });
  };

  return (
    <Paper classes={{ root: classes.paper }}>
      <Container maxWidth='lg'>
        <Box display='flex' justifyContent='center' my={2}>
          <img alt='' src={icwLogo} width='200px' heigth='200px' />
        </Box>
        <Box display='flex' justifyContent='center' my={2} fontSize='32px' fontWeight='bold'>
          {T.translate('productManager.shareFilesTo', { companyName: files.company })}
        </Box>
        <Box display='flex' justifyContent='space-between' my={2}>
          <Box fontSize='14px' fontWeight='500'>
            {T.translate('productManager.expireAt', { date: files.date })}
          </Box>
          <Button onClick={handleDownloadAll}>
            <Box fontSize='14px' fontWeight='500'>
              {T.translate('productManager.downloadAll')}
            </Box>
          </Button>
        </Box>
        <Box display='flex' justifyContent='center' my={2}>
          <TableContainer component={Paper}>
            <Table classes={{ root: classes.table }}>
              <TableHead>
                <TableRow>
                  <TableCell classes={{ root: classes.tableHead }}>
                    {T.translate('productManager.item')}
                  </TableCell>
                  <TableCell classes={{ root: classes.tableHead }} align='right'>
                    {T.translate('productManager.owner')}
                  </TableCell>
                  <TableCell classes={{ root: classes.tableHead }} align='right'>
                    {T.translate('productManager.fileSize')}
                  </TableCell>
                  <TableCell classes={{ root: classes.tableHead }} align='right'>
                    {T.translate('productManager.lastModified')}
                  </TableCell>
                  <TableCell classes={{ root: classes.tableHead }} align='right'>
                    {T.translate('productManager.expiryDate')}
                  </TableCell>
                  <TableCell classes={{ root: classes.tableHead }} align='right' />
                </TableRow>
              </TableHead>
              <TableBody>
                {files.files &&
                  Object.keys(files.files).map((key) =>
                    files.files[key].fileArr.map((file) => {
                      return (
                        <TableRow key={file.id}>
                          <TableCell component='th' scope='row'>
                            <Box fontSize='12px'>{file.name}</Box>
                          </TableCell>
                          <TableCell align='right'>
                            <Box fontSize='12px' color='#999999'>
                              {file.owner}
                            </Box>
                          </TableCell>
                          <TableCell align='right'>
                            <Box fontSize='12px' color='#999999'>
                              {file.size ? formatBytes(file.size, 2) : '/'}
                            </Box>
                          </TableCell>
                          <TableCell align='right'>
                            <Box fontSize='12px' color='#999999'>
                              {file.updatedAt}
                            </Box>
                          </TableCell>
                          <TableCell align='right'>
                            <Box fontSize='12px' color='#999999'>
                              {file.expiryDate ? moment(file.expiryDate).format('YYYY-MM-DD') : ''}
                            </Box>
                          </TableCell>
                          <TableCell align='right'>
                            <Button variant='text' href={file.url}>
                              <Box fontSize='12px' color='#2154A2'>
                                {T.translate('productManager.download')}
                              </Box>
                            </Button>
                          </TableCell>
                        </TableRow>
                      );
                    })
                  )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Container>
    </Paper>
  );
};

export default SharePage;
